import React from 'react';
import { MAINTENANCE_CONFIG } from './config/maintenance';

const MaintenancePage = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      fontFamily: 'Arial, sans-serif',
      padding: '20px',
      textAlign: 'center'
    }}>
      {/* Icon */}
      <div style={{
        width: '120px',
        height: '120px',
        background: 'rgba(255, 255, 255, 0.2)',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '32px',
        backdropFilter: 'blur(10px)'
      }}>
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
        </svg>
      </div>

      {/* Title */}
      <h1 style={{
        fontSize: '48px',
        fontWeight: '700',
        color: 'white',
        margin: '0 0 16px 0',
        textShadow: '0 2px 20px rgba(0,0,0,0.2)'
      }}>
        {MAINTENANCE_CONFIG.title}
      </h1>

      {/* Description */}
      <p style={{
        fontSize: '18px',
        color: 'rgba(255, 255, 255, 0.9)',
        maxWidth: '500px',
        lineHeight: '1.6',
        margin: '0 0 32px 0',
        textShadow: '0 1px 10px rgba(0,0,0,0.1)'
      }}>
        {MAINTENANCE_CONFIG.message}
      </p>

      {/* Loading animation */}
      <div style={{
        display: 'flex',
        gap: '12px',
        marginBottom: '32px'
      }}>
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            style={{
              width: '12px',
              height: '12px',
              background: 'white',
              borderRadius: '50%',
              animation: `bounce 1.4s infinite ease-in-out ${i * 0.16}s`,
              boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
            }}
          />
        ))}
      </div>

      {/* Contact info */}
      <p style={{
        fontSize: '14px',
        color: 'rgba(255, 255, 255, 0.7)',
        margin: '0'
      }}>
        Questions? Contact us at <a href={`mailto:${MAINTENANCE_CONFIG.contactEmail}`} style={{ color: 'white', textDecoration: 'underline' }}>{MAINTENANCE_CONFIG.contactEmail}</a>
      </p>

      <style>{`
        @keyframes bounce {
          0%, 80%, 100% { 
            transform: translateY(0);
            opacity: 0.7;
          }
          40% { 
            transform: translateY(-20px);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default MaintenancePage;